import React, { ReactNode } from 'react';

interface WidgetContentProps {
  children?: ReactNode;
}

const WidgetContent: React.FC<WidgetContentProps> = ({ children }) => {
  return <div className="widget-content">{children}</div>;
};

export default WidgetContent;
